import * as React from 'react';
import { BaseReactSettingsCtrlProps } from '../../../controllers/BaseReactSettingsCtrl';
import { IServerAdminSettings } from '../../../types/ISite';
import { SectionContainerBaseProps, SettingsFormikContainer } from '../GeneralSettingsPageBase';
import { ISiteAdminSettingsWithSubscriptions } from '../../../types/ISiteSettingsForSiteAdmin';

export interface PropOverridesForSiteSettings {
  showEncryptionStatus?: boolean;
  createSite?: boolean;
}

/**
 * A partial list of site settings for server admin.
 * This is meant for individual section components to pick a subset of the overall settings they use
 */
export type SiteSettingsForSiteAdminProps<T extends keyof ISiteAdminSettingsWithSubscriptions = keyof ISiteAdminSettingsWithSubscriptions> = {
  siteId?: string;
  settings: Pick<ISiteAdminSettingsWithSubscriptions, T>;
} & PropOverridesForSiteSettings;

export type serverSettingsForSiteAdmin = {serverSettings: Pick<IServerAdminSettings, 'defaultStartPage'>}

export type OuterSiteSettingsForSiteAdminProps = BaseReactSettingsCtrlProps & SectionContainerBaseProps
  & SiteSettingsForSiteAdminProps & serverSettingsForSiteAdmin;

export function ReactSiteSettingsForSiteAdmin(props: OuterSiteSettingsForSiteAdminProps){
  return <SettingsFormikContainer {...props} />;
}
